export default __webpack_public_path__ + "static/media/banner.e215e20a.jpg";